import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function mustBeTrueValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => control.value === true ? null : {"mustBeTrue": true};
}